module.exports = __webpack_public_path__ + "static/animation-talk-baloon01-e3841aee1a3055c1a0e195c33a574d43.png";